export const API_ENDPOINT_PREFIX = import.meta.env.VITE_API_ENDPOINT_PREFIX;
export const COMMIT_ID = import.meta.env.VITE_COMMIT_ID;
export const DEV_BAR_COLOR = import.meta.env.VITE_DEV_BAR_COLOR;
export const WEBSITE_NAME = import.meta.env.VITE_WEBSITE_NAME;
export const WEBSITE_NAME_SHORT = import.meta.env.VITE_WEBSITE_NAME_SHORT;

export const ADB2C_APPLICATION_ID = import.meta.env.VITE_ADB2C_APPLICATION_ID;
export const ADB2C_INSTANCE = import.meta.env.VITE_ADB2C_INSTANCE;
export const ADB2C_INVITATION_POLICY = import.meta.env
  .VITE_ADB2C_INVITATION_POLICY;
export const ADB2C_MFA_RENEW_POLICY = import.meta.env
  .VITE_ADB2C_MFA_RENEW_POLICY;
export const ADB2C_POLICY = import.meta.env.VITE_ADB2C_POLICY;
export const ADB2C_REDIRECT_URI = import.meta.env.VITE_ADB2C_REDIRECT_URI;
export const ADB2C_SIGNUP_POLICY = import.meta.env.VITE_ADB2C_SIGNUP_POLICY;
export const ADB2C_TENANT = import.meta.env.VITE_ADB2C_TENANT;
export const ADB2C_SCOPE_DOMAIN = import.meta.env.VITE_ADB2C_SCOPE_DOMAIN;
export const ADB2C_SCOPES = [
  `https://${ADB2C_SCOPE_DOMAIN}/${ADB2C_APPLICATION_ID}/general`,
];

export const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE;
export const DISABLE_AUTO_LOGOUT = import.meta.env.VITE_DISABLE_AUTO_LOGOUT;
